'use client'

import { useEffect } from 'react'
import { usePostHog } from 'posthog-js/react'
import { useAuthContext } from '@/contexts/AuthContext'

export default function PostHogIdentifiy(): null {
  const posthog = usePostHog()

  const { user, isAuthenticated, currentOrganization } = useAuthContext()
  const { userId } = user ?? {}

  useEffect(() => {
    // Identify the user if they aren't already
    if (isAuthenticated && userId && user && !posthog._isIdentified()) {
      const currentProfile = user.profiles[0]
      posthog.identify(userId, {
        email: user.email ?? currentProfile?.email ?? undefined,
        username: user.name ?? currentProfile?.name ?? undefined,
        title: currentProfile?.title ?? undefined,
        institution: currentProfile?.institution ?? undefined,
        organization: currentOrganization?.name ?? undefined,
        organizationId: currentOrganization?.id ?? undefined,
      })
    }

    // Reset the user if they sign out
    if (!isAuthenticated && posthog._isIdentified()) {
      posthog.reset()
    }
  }, [posthog, user])

  return null
}
